import { IUserInfoItem } from "@valenzinsights/react-core";

import { profileListItem } from "./profileListItem";

let appToken: any = {};

export const userInfoItem = {
	title: appToken.name || "",
	designation: appToken.UserRole || "",
};

export const userConfiguration: IUserInfoItem = {
	items: [profileListItem],
	isTabView: false,
	userPersonaldata: userInfoItem,
};

export * from "./profileListItem";
